import { useQuery } from '@tanstack/react-query'
import type { ISpRewardsSummary } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

export function useSpRewardsSummary() {
  return useQuery({
    queryKey: queryKeys.spRewards.summary(),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpRewardsSummary>>(
        '/api/v1/sp/rewards/summary',
      )
      return data.data
    },
  })
}
